import { render } from "./Passive.vue?vue&type=template&id=c29eea5e&scoped=true"
import script from "./Passive.vue?vue&type=script&lang=js"
export * from "./Passive.vue?vue&type=script&lang=js"

import "./Passive.vue?vue&type=style&index=0&id=c29eea5e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29eea5e"]])

export default __exports__